import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IDependent, IEmployee } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

import { useInvalidateEmployeeData } from "./useGetEmployeeData";

type Params = {
  countryCode: number;
  clientInternalNumberGOS: number;
  employeeDependentTag: number;
  payload: IDependent;
};

const updateDependent = async ({
  countryCode,
  clientInternalNumberGOS,
  employeeDependentTag,
  payload,
}: Params) => {
  const response = await api.patch(
    `/employee/dependent/${countryCode}/${clientInternalNumberGOS}/${employeeDependentTag}`,
    payload
  );
  return response.data as IDependent;
};

export function useUpdateDependent(refetch = true) {
  const queryClient = useQueryClient();

  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateEmployeeData = useInvalidateEmployeeData();

  return useMutation(updateDependent, {
    mutationKey: MUTATION_KEYS.updateDependent,
    onSuccess: (updatedDependent) => {
      if (refetch) {
        invalidateEmployeeData();
      } else {
        const employeeQueryData = queryClient.getQueryData([
          QUERY_KEYS.employeeData,
          updatedDependent.countryCode?.toString(),
          updatedDependent.clientInternalNumberGos?.toString(),
        ]) as IEmployee;

        const employeeWithUpdatedDependent = {
          ...employeeQueryData,
          dependents: employeeQueryData?.dependents?.map((dependent) => {
            if (dependent.employeeDependentTag === updatedDependent.employeeDependentTag) {
              return updatedDependent;
            }
            return dependent;
          }),
        };
        queryClient.setQueriesData(
          [
            QUERY_KEYS.employeeData,
            updatedDependent.countryCode?.toString(),
            updatedDependent.clientInternalNumberGos?.toString(),
          ],
          employeeWithUpdatedDependent
        );
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
